<div>
  <div *ngFor="let option of options" class="tw-py-1">
    <label class="font-weight-normal form-check-label text-nowrap" style="cursor: pointer">
      <input type="checkbox" value="option.value" [checked]="option.selected" (change)="option.selected = $event.target.checked" /> {{ option.label }}
    </label>
  </div>
</div>
